import React from "react";
import { Navigate } from "react-router-dom";
import useCurrentUserAccess from "../hooks/useCurrentUserAccess";

export default function PlatformAdminRoute({ children }) {
  const { loading, platformRole } = useCurrentUserAccess();

  if (loading) {
    return <div style={{ padding: 24 }}>Loading...</div>;
  }

  if (platformRole?.key_name !== "platform_admin") {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}